import React from "react";
import "./ReviewsAverage.scss";
import ReviewProgress from "../ReviewProgress/ReviewProgress";
import { locale } from "../../translate/sweden";

const ReviewsAverage = ({ rating, reviewsLen, grades }) => {
  return (
    <div className="ReviewAverage">
      <div className="mark">
        <p>
          {rating} {locale.of} 5
        </p>
        <span>
          ({reviewsLen} {locale.startPage.recensions})
        </span>
      </div>

      <div className="statistics">
        <div className="flex">
          <p>★★★★★</p>
          <ReviewProgress completed={grades["5"] ? grades["5"] * 100 : 0} />
        </div>
        <div className="flex">
          <p>★★★★</p>
          <ReviewProgress completed={grades["4"] ? grades["4"] * 100 : 0} />
        </div>
        <div className="flex">
          <p>★★★</p>
          <ReviewProgress completed={grades["3"] ? grades["3"] * 100 : 0} />
        </div>
        <div className="flex">
          <p>★★</p>
          <ReviewProgress completed={grades["2"] ? grades["2"] * 100 : 0} />
        </div>
        <div className="flex">
          <p>★</p>
          <ReviewProgress completed={grades["1"] ? grades["1"] * 100 : 0} />
        </div>
      </div>
    </div>
  );
};

export default ReviewsAverage;
